var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"tagcloud",attrs:{"color":"#333","max-width":"250","flat":""}},[_c('v-card-text',_vm._l((this.reorderList),function(item,index){return _c('span',{key:index,staticClass:"word",class:_vm.getWordSize(index)},[_vm._v(_vm._s(item.keyword)+" ")])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }